import { initializeApp, FirebaseApp } from 'firebase/app';
import { initializeFirestore, Firestore } from 'firebase/firestore';
import { getFunctions, Functions } from 'firebase/functions';
import { environment } from '../../environments/environment';

let app: FirebaseApp;
let firestore: Firestore;
let functions: Functions;

export const getFirebaseApp = () => {
  if (!app) {
    app = initializeApp(environment.firebase);
  }
  return app;
}

export const getFirebaseFirestore = () => {
  if (!firestore) {
    firestore = initializeFirestore(getFirebaseApp(), { ignoreUndefinedProperties: true });
  }
  return firestore;
}

export const getFirebaseFunctions = () => {
  if (!functions) {
    functions = getFunctions(getFirebaseApp(), 'southamerica-east1');
  }
  return functions;
}
